import { render, staticRenderFns } from "./I18nGroupAccordion.vue?vue&type=template&id=4d4809bb&scoped=true&"
import script from "./I18nGroupAccordion.vue?vue&type=script&lang=js&"
export * from "./I18nGroupAccordion.vue?vue&type=script&lang=js&"
import style0 from "./I18nGroupAccordion.vue?vue&type=style&index=0&id=4d4809bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4809bb",
  null
  
)

export default component.exports